module.exports = __webpack_public_path__ + "static/media/point4.8ce0cffe.png";